import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-check-state',
  templateUrl: './check-state.component.html',
})
export class CheckStateComponent implements OnInit {
  _cls: any = 'check-state-default';
  @Input('cls') set cls(cls: any) {
    this._cls = cls;
  }

  _state: any = '';
  @Input('state') set state(state: any) {
    this._state = state;
  }

  _value: any = '';
  @Input('value') set value(value: any) {
    this._value = value;
  }

  @Output('change') change = new EventEmitter();

  ngOnInit(): void {}

  checked() {
    this.change.emit(this._value);
  }
}
